(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    if ($(window).width() < 768) {
      $('.wl-featured-blog .article-list').slick({
        responsive: [
          {
            breakpoint: 767,
            settings: {
              infinite: false,
              autoplay: false,
              arrows: false,
              slidesToShow: 1.2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  $(document).ready(function() {
    $('.hl-mobile select').on('change', function(){
      let tag = $(this).val();
      let newRelativePath = tag;
      window.history.pushState(null, '', newRelativePath);
      $('.main-blog--left').load(location.href + " .main-blog--left > *");
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-column"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    if ($(window).width() < 768) {

      $('.hemplucid-lovers .flexible-layout').slick({
        responsive: [
          {
            breakpoint: 767,
            settings: {
              infinite: false,
              autoplay: false,
              arrows: false,
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          }
        ]
      });

    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-atc-drawer"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    let open = false;
    $('.atc-close').on('click', function() {
        $('.atc-drawer').animate({right: '-440px'}, "fast");
        $('.atc-close').removeClass('active');
        $('.atc-drawer--wrapper').fadeOut();
    });

    $('.atc-trigger').on('click', function() {
        alert('clicked atc in cart');
        let handle = $(this).data('handle');
        $('.atc-drawer--wrapper').fadeIn();
        $('.atc-drawer').animate({right: '0px'}, "fast");
        $('.atc-close').addClass('active');
        open = true;

        updateDrawer(handle,open);
    });

      $('.atc-image-gallery').slick({
        infinite: false,
        autoplay: false,
        arrows: false,
        dots: true,
        slidesToShow: 1.5,
        slidesToScroll: 1
      });
  });

  function updateDrawer(handle, open) {
    alert("Got here, "+handle+", "+open);
    fetch(window.Shopify.routes.root + 'products/'+handle+'.js')
    .then(response => response.json())
    .then(product => {

    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-featured-collections"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.pill-btn').on('click', function(e){
    $('.pill-btn').toggleClass('active');
    $('.collection-listing').toggleClass('active');
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-related-articles"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
    let width = $(window).width();
    if(width < 768) {
        $('.article-list--with-images').slick({
            infinite: false,
            autoplay: false,
            arrows: true,
            appendArrows: $('.mobile-controls'),
            prevArrow: `<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <mask id="mask0_451_3545" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_451_3545)">
    <path d="M10.0001 21.3079L0.692383 12.0001L10.0001 2.69238L11.0636 3.75588L2.81938 12.0001L11.0636 20.2444L10.0001 21.3079Z" fill="#1C1B1F"/>
  </g>
</svg></button>`,
            nextArrow: `<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <mask id="mask0_451_3542" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_451_3542)">
    <path d="M8.00588 21.3079L6.94238 20.2444L15.1866 12.0001L6.94238 3.75588L8.00588 2.69238L17.3136 12.0001L8.00588 21.3079Z" fill="#1C1B1F"/>
  </g>
</svg></button>`,
            dots: false,
            slidesToShow: 1.1,
            slidesToScroll: 1,
        });
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-subscribiption-benefit-cards"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  if ($(window).width() < 768) {
    if( $('.shop-card.mobile-carousel').length ){
      $('.shop-card.mobile-carousel').appendTo('.no-customer .benefits-card--container .shop-card--mobile');
    }

    $('.benefits-card--wrapper.mobile-carousel').slick({
      responsive: [
        {
          breakpoint: 767,
          settings: {
            infinite: false,
            autoplay: false,
            arrows: false,
            slidesToShow: 1.2,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-tabbed-collections"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
    $('.collection-tab').on('click', function(){
        let id = $(this).data('id');
        $('.collection-tab').removeClass('active');
        $(this).addClass('active');
        $('.page-collection.tabbed').removeClass('active');
        $('[data-section-id="'+id+'"]').addClass('active');
    });
});

  } catch(e) { console.error(e); }
})();
})();
